/**
 * @Pipe
 * All sharednservices
 *
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'mime'})

export class MimePipe implements PipeTransform {
  transform(value: string): string {
    let expl = value.split('.');
    return expl[expl.length - 1].toUpperCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/mime.pipe.ts